import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

class FirebaseService {
  private static instance: FirebaseService;
  private initialized = false;

  private constructor() {}

  public static getInstance(): FirebaseService {
    if (!FirebaseService.instance) {
      FirebaseService.instance = new FirebaseService();
    }
    return FirebaseService.instance;
  }

  public async initialize(firebaseConfig: any): Promise<boolean> {
    if (this.initialized) {
      console.log('Firebase already initialized by this service. Skipping...');
      return true;
    }

    try {
      // Get the app if it exists, or initialize it if it doesn't
      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
      
      // Initialize Firestore
      const db = getFirestore(app);

      // Initialize Storage — used by the image-question upload flow
      // (ImageUploadService.ts) for customer photo answers.
      getStorage(app);

      // Enable offline persistence
      try {
        await enableIndexedDbPersistence(db);
        console.log('Firestore persistence enabled successfully');
      } catch (error: any) {
        console.error('Error enabling Firestore persistence:', error.message);
        // Continue anyway as this is not critical
      }
      
      this.initialized = true;
      console.log('Firebase initialized successfully');
      return true;
    } catch (error: any) {
      console.error('Error initializing Firebase:', error.message);
      return false;
    }
  }

  public isInitialized(): boolean {
    return this.initialized;
  }
}

export default FirebaseService;